// extracted by mini-css-extract-plugin
export var container = "ribbon-module--container--81262";
export var ribbonText = "ribbon-module--ribbon-text--571b7";
export var stamp = "ribbon-module--stamp--784b8";
export var stampRound = "ribbon-module--stamp-round--bd9b5";
export var sygnet = "ribbon-module--sygnet--1dfaa";